var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesertBadgeGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 64,
    viewBox: "0 0 252 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 47650",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4095",
    x: 202.234,
    y: -91.7466,
    width: 58,
    height: 233.926,
    transform: "rotate(42.9925 202.234 -91.7466)",
    fill: "url(#paint0_linear_3646_13956)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4097",
    x: 159.812,
    y: -131.297,
    width: 58,
    height: 233.926,
    transform: "rotate(42.9925 159.812 -131.297)",
    fill: "url(#paint1_linear_3646_13956)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4096",
    x: 244.66,
    y: -52.1965,
    width: 58,
    height: 233.926,
    transform: "rotate(42.9925 244.66 -52.1965)",
    fill: "url(#paint2_linear_3646_13956)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3646_13956",
    x1: 231.563,
    y1: -48.9845,
    x2: 231.104,
    y2: 142.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d79056",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f2e5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3646_13956",
    x1: 194.762,
    y1: -84.6323,
    x2: 186.462,
    y2: 102.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d79056",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f2e5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3646_13956",
    x1: 279.61,
    y1: -5.53174,
    x2: 271.31,
    y2: 181.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d79056",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9f2e5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesertBadgeGrad);
export default __webpack_public_path__ + "static/media/desertBadgeGrad.a58c995bbdd55cd9185d5b7dd42c8b4f.svg";
export { ForwardRef as ReactComponent };